module.exports = __webpack_public_path__ + "static/media/i20.b4b1108e.png";